import { removeMdnFormatting } from "@expert/common-ui";
import { useMemo } from "react";

import { isBlocklisted } from "@/customer-panel/components/customer-verification/utils/isBlocklisted";
import { useTypedMostRecentTask } from "@/sdk";

interface UseTaskMdnProps {
    blocklistedNumbers?: string[];
    blocklistedPrefixes?: string[];
}

export const useTaskMdn = ({ blocklistedNumbers, blocklistedPrefixes }: UseTaskMdnProps) => {
    const { isVoice, isChat, voiceTask, chatTask } = useTypedMostRecentTask();

    const taskMdn = useMemo(() => {
        let mdn = "";

        if (isVoice && voiceTask) {
            mdn = voiceTask.mdn ?? "";
        } else if (isChat && chatTask) {
            // The chat task's mdn comes in formatted with the mask used in the chat UI, so we need to remove that formatting
            const unformattedMdn = removeMdnFormatting(chatTask.mdn.value ?? "");

            mdn = unformattedMdn.length === 10 ? `+1${unformattedMdn}` : unformattedMdn;
        }

        return isBlocklisted(mdn, blocklistedNumbers, blocklistedPrefixes) ? "" : mdn;
    }, [isVoice, isChat, voiceTask, chatTask, blocklistedNumbers, blocklistedPrefixes]);

    return taskMdn;
};
